<template>
	<v-container>
		<v-form v-model="permiteGuardar">
			<v-row>
				<v-col cols="12" sm="2">
					<v-text-field label="Folio de Solicitud" 
						v-model="datosAsignacion.idSolicitud" 
						readonly
					></v-text-field>
				</v-col>
				<v-col cols="12" sm="2">
					<v-text-field 
						label="Fecha de Solicitud" 
						v-model="datosAsignacion.fechaSolicitud" 
						readonly
					></v-text-field>
				</v-col>
				<v-col cols="12" sm="3">
					<v-text-field 
						label="Estatus de Solicitud" 
						v-model="datosAsignacion.status" 
						readonly
					></v-text-field>
				</v-col>
				<v-col cols="12" sm="5">
					<v-text-field 
						label="Nombre del Paciente" 
						v-model="datosAsignacion.paciente" 
						readonly
					></v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" sm="6">
					<v-combobox
						label="Estatus Intervención"
						v-model="statusIntervencion"
						:items="statusIntervencionLista"
						item-text="descripcion"
						item-value="id"
						:rules="statusRules"
					></v-combobox>
				</v-col>
				<v-col cols="12" sm="2">
					<v-text-field 
						label="Teléfono 1" 
						v-model="datosAsignacion.tel1" 
						readonly
					></v-text-field>
				</v-col>
				<v-col cols="12" sm="2">
					<v-text-field 
						label="Teléfono 2" v-model="datosAsignacion.tel2" 
						readonly
					></v-text-field>
				</v-col>
				<v-col cols="12" sm="2">
					<v-text-field 
						label="Teléfono 3" 
						v-model="datosAsignacion.tel3" 
						readonly
					></v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" sm="6">
					<v-textarea
						label="Anotaciones"
						v-model="anotaciones"
						rows="5"
						background-color="teal lighten-5"
						color="teal teal-darken-4"
						prepend-icon="mdi-comment"
						:counter="3000"
						:rules="anotacionesRules"
					>
					</v-textarea>
				</v-col>
				<v-col cols="12" sm="6">
					<v-textarea
						label="Observaciones"
						v-model="observaciones"
						rows="5"
						background-color="teal lighten-5"
						color="teal teal-darken-4"
						prepend-icon="mdi-comment"
						:counter="3000"
						:rules="observacionesRules"
					>
					</v-textarea>
				</v-col>
			</v-row>
			<v-row>
				<v-btn color="info" :disabled="!permiteGuardar" @click="guardaAsignacion">Guardar</v-btn>
				<v-spacer></v-spacer>
				<v-btn color="success" @click="cancelar">Cancelar</v-btn>
			</v-row>
		</v-form>
	</v-container>
</template>

<script>
import ServiciosApi from '@/services/ServiciosApi.js'
export default {
	name: 'DetalleAsignacion',
	data () {
		return {
			folio: 0,
			anotaciones: '',
			observaciones: '',
			permiteGuardar: true,
			respuesta: '',
			statusIntervencion: '',
			statusIntervencionLista: [],
			respuestaStatusIntervencion: '',
			anotacionesRules: [
				v => !!v || "Debe especificarse alguna anotación",
				v => v.length <= 3000 || "El máximo de caracteres es de 3,000"
			],
			observacionesRules: [
				v => v.length <= 3000 || "El máximo de caracteres es de 3,000"
			],
			statusRules: [
				v => !!v || "Debe seleccionarse un dato"
			],
		}
	},
	props: {
		datosAsignacion: {
			type: Object,
			required: true,
		}
	},
	mounted: function(){
		ServiciosApi.statusPorTipo(6)
			.then(response => {
				this.respuestaStatusIntervencion = response.data
				this.statusIntervencionLista = this.respuestaStatusIntervencion.datos
			})
			.catch(error => {
				console.log("Hubieron errores al obtener los estatus", error.response)
			})
	},
	methods: {
		guardaAsignacion() {
			let infoAsignacion = {
				notas: this.anotaciones,
				observaciones: this.observaciones,
				idSolicitud: this.datosAsignacion.idSolicitud,
				idStatus: this.statusIntervencion.id
			}
			console.log("Datos de Asignacion",infoAsignacion)
			ServiciosApi.nuevaLlamadaAsignacion(infoAsignacion)
				.then(response => {
					this.respuesta = response.data
					console.log("Datos", this.respuesta)
				})
				.catch(error =>{
					console.log("Hubieron errores", error.response)
				})
			this.$emit('cancela-detalle', 0)
		},
		cancelar(){
			this.folio = 0
			this.$emit('cancela-detalle', this.folio)
		},
	},
}
</script>
